import PortalOrdersContainer from '@components/containers/b2b/portal/PortalOrders';
import { B2B_NAV_ITEMS } from '@constants/sidebar';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const PortalOrders: FC = () => (
    <VendorLayout navItems={B2B_NAV_ITEMS}>
        <PortalOrdersContainer />
    </VendorLayout>
);

export default PortalOrders;
